import React from 'react';
import { Card, CardHeader, CardBody, Row } from "reactstrap";
import { Line } from "react-chartjs-2";
import { GetHeader, Loading, ApiError } from '../../utils/Utilities';
import axios from 'axios';

class TotalSchedules extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: props.currentUser,
            loading: false,
            activeNav: 1,
            data: null
        };
    }
    handleValue = (name, value) => { this.setState({ [name]: value }); }

    componentDidMount() {
        this.getTotalSchedulesGraph();
    }

    getTotalSchedulesGraph = () => {
        var headers = GetHeader();
        axios.get(global.api_url + "Graph/GetTotalSchedules", { headers })
            .then((response) => {
                if (response.status === 200) {
                    this.handleValue("data", response.data)
                }
                this.handleValue("loading", false)
            }).catch(error => {
                this.handleValue("loading", false)
                ApiError(error, "Gráfico: Total de agendamentos").then(call => call === true ? this.getTotalSchedulesGraph() : "");
            });


    }


    render() {
        const { data, loading } = this.state;

        const options = {
            options: {
                scales: {
                    yAxes: [
                        {
                            gridLines: {
                                color: "#e3231a",
                                zeroLineColor: "#e3231a",
                            },
                            ticks: {
                                callback: function (value) {
                                    if (!(value % 10)) {
                                        return "$" + value + "k";
                                    }
                                },
                            },
                        },
                    ],
                },
                tooltips: {
                    callbacks: {
                        label: function (item, data) {
                            var label = data.datasets[item.datasetIndex].label || "";
                            var yLabel = item.yLabel;
                            var content = "";

                            if (data.datasets.length > 1) {
                                content += label;
                            }

                            content += "$" + yLabel + "k";
                            return content;
                        },
                    },
                },
            },
        }

        return (

            <Card className="bg-gradient-neutral shadow">
                <CardHeader className="bg-transparent">
                    <Row className="align-items-center">
                        <div className="col">
                            <h6 className="text-uppercase text-dark ls-1 mb-1">
                                Agendamentos
                            </h6>
                            <h2 className="text-dark mb-0">Por mês</h2>
                        </div>
                    </Row>
                </CardHeader>
                <CardBody>
                    <div className="chart">
                        {loading === true || data === null ?
                            Loading(true) :
                            <Line
                                data={data}
                                options={options}
                                getDatasetAtEvent={(e) => console.log(e)}
                            />
                        }
                    </div>
                </CardBody>
            </Card>

        );
    }
}

export default TotalSchedules;

